import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export default function ChatbotContact({ show, setShow, contactInfo, phoneNumbers }) {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ height: 0 }}
      animate={{ height: show ? 'auto' : 0 }}
      className="border-t overflow-hidden"
    >
      <div className="p-4 bg-gradient-to-b from-blue-50 to-white h-56 overflow-y-auto">
        <div className="space-y-3">
          <div className="bg-blue-600 text-white p-4 rounded-xl text-center">
            <p className="font-bold">{contactInfo.headline}</p>
            <a href={`tel:${phoneNumbers[0]?.replace(/[^+\d]/g, '')}`} className="inline-block bg-white text-blue-700 px-6 py-2 mt-2 rounded-lg font-bold">
              {contactInfo.primaryAction}: {phoneNumbers[0]}
            </a>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <a href={`tel:${phoneNumbers[1]?.replace(/[^+\d]/g, '')}`} className="bg-white border-2 border-blue-200 text-blue-700 p-2 rounded-lg text-center text-sm">
              {contactInfo.alternateAction}
            </a>
            <a href={`mailto:${contactInfo.email}`} className="bg-white border-2 border-blue-200 text-blue-700 p-2 rounded-lg text-center text-sm">
              {contactInfo.emailAction}
            </a>
          </div>
          <div className="bg-white border p-3 rounded-lg">
            <h4 className="font-bold text-sm">{contactInfo.servicesHeadline}</h4>
            <ul className="text-xs space-y-1 mt-1">
              {contactInfo.services.map((s, i) => <li key={i}>• {s}</li>)}
            </ul>
          </div>
        </div>
      </div>
      <button
        onClick={() => setShow(!show)}
        className="w-full py-2 bg-blue-600 text-white text-sm"
      >
        {show ? t('chatbot.widget.buttons.hide_contact') : t('chatbot.widget.buttons.show_contact')}
      </button>
    </motion.div>
  );
}